module.exports = __webpack_public_path__ + "img/41.537e56b9.png";